/** The boolean state updater a `useState` setter takes to flip its value: `setOpen(flipped)` opens a closed panel and closes an open one. */
export function flipped(previous: boolean): boolean {
	return !previous;
}
